import {getRequestHeader, getRequestHost, getRequestProtocol} from 'vinxi/http'
import {queryOptions} from '@tanstack/react-query'
import {createServerFn} from '@tanstack/start'
import {
    IS_DEVELOPMENT,
    SANITY_DATASET,
    SANITY_PROJECT_ID,
    SPREADSHOP_IMAGE_SERVER_ENDPOINT,
} from '~/constants'
import fetchShopDetails from '~/client/spreadshop/new/fetchShopDetails'
import {applyServerFnCache} from '~/client/fn/utils'
import {isbot} from 'isbot'

const CACHE_TIME_SEC = 60 * 60 * 24 // 24h

export const getShopDetails = createServerFn({
    method: 'GET',
}).handler(async () => {
    const shopDetails = await fetchShopDetails()

    applyServerFnCache(CACHE_TIME_SEC)

    return {
        endpoint: `${getRequestProtocol()}://${getRequestHost()}`,
        isDevelopment: IS_DEVELOPMENT,
        isBot: isbot(getRequestHeader('User-Agent')),
        imageServerEndpoint: SPREADSHOP_IMAGE_SERVER_ENDPOINT,
        cms: {
            projectId: SANITY_PROJECT_ID,
            dataset: SANITY_DATASET,
        },
        ...shopDetails,
    }
})

export const shopQueryOptions = () =>
    queryOptions({
        queryKey: ['shop'],
        gcTime: 1000 * CACHE_TIME_SEC, // 24h
        staleTime: 1000 * CACHE_TIME_SEC, // 24h,
        queryFn: () => getShopDetails(),
    })
